<template>
  <div>
    <b-card class="card-custom card-border">
      <div class="font-weight-bold mb-3">Server Details</div>
      <b-list-group flush>
        <b-list-group-item class="d-flex align-items-center px-0">
          Name
          <span class="ml-auto">{{ selectedServer.name }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center px-0">
          Location
          <span class="ml-auto">
            <div class="d-flex align-items-center px-0">
              <img
                :src="countryFlag(selectedServer.country)"
                :alt="selectedServer.country"
                class="w-20px mr-2 no-select rounded-sm bg-light border border-light rounded-sm" />
              <span
                class="d-inline-block mr-1 text-truncate"
                style="max-width: 180px;">{{ countryName(selectedServer.country) }}, {{ selectedServer.location }}</span>
            </div>
          </span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center px-0">
          IP
          <span class="ml-auto">{{ selectedServer.ip }}</span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center px-0">
          Status
          <span class="ml-auto font-size-xs">
            <b-badge :variant="serverStatusBadge(selectedServer).variant">
              <i :class="`fa fa-sm fa-${serverStatusBadge(selectedServer).icon} text-white`"></i>
              {{ serverStatusBadge(selectedServer).text }}
            </b-badge>
          </span>
        </b-list-group-item>
        <b-list-group-item class="d-flex align-items-center px-0">
          Client Version
          <span class="ml-auto">
            <span v-if="selectedServer.client_version">
              <span class="font-size-xs">v</span>
              <span>{{ selectedServer.client_version }}</span>
            </span>
            <i
              v-else
              class="fa fa-minus fa-xs opacity-50" />
          </span>
        </b-list-group-item>

        <!-- custom item -->
        <b-list-group-item
          v-if="customItem === 'cloudflate_installed'"
          class="d-flex align-items-center px-0">
          Cloudflare Proxy rules
          <span class="ml-auto">
            {{ savedCloudflareRulesLength }}
          </span>
        </b-list-group-item>
        <b-list-group-item
          v-if="customItem === 'vpn_installed'"
          class="d-flex align-items-center px-0">
          VPN Servers Installed
          <span class="ml-auto">{{ installedVpnServersCount }} / {{ totalVpnServers }}</span>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ServerDetailsPlate',
  props: {
    customItem: {
      type: String,
      required: true,
      default: () => 'vpn_installed',
    },
  },
  computed: {
    ...mapGetters([
      'countryFlag',
      'countryName',

      'selectedServer',
      'selectedServerId',
      'serverStatusBadge',

      'cloudflareInstalled',
      'savedCloudflareRulesLength',

      'installedVpnServersCount',
      'totalVpnServers',
    ]),
  }
}
</script>
